import React, { useState } from 'react';
import {
  Grid,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableFooter,
  TableBody,
  Paper,
  TableContainer,
} from '@material-ui/core';
import './commodityDetailsSummary.scss';
import { DASHBOARD_COMMODITY, CLERANCE_DECLARATION } from '../../../../utils/constants/constants';

const CommodityDetailsSummary = ({ shipmentDetails, isClearance, shipmentMovementType, isInternational }) => {
  const [isAddNewAddress, setIsAddNewAddress] = useState(false);
  return (
    <Grid className="commodity-main-grid">
      <Grid container direction="row" justify="space-between">
        <Grid item className="commodity-item-detail">
          <strong>{DASHBOARD_COMMODITY.ITEM_DETAILS}</strong>
        </Grid>
      </Grid>
      <TableContainer component={Paper} className="tableContainer">
        <Table aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left">
                <strong>{DASHBOARD_COMMODITY.COMMODITY_CODE}</strong>
              </TableCell>
              <TableCell align="left">
                <strong>{isInternational ? DASHBOARD_COMMODITY.FULL_DESCRIPTION_GOODS : DASHBOARD_COMMODITY.DESCRIPTION_GOODS}</strong>
              </TableCell>
              {isInternational ||
              (!isInternational && shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B) ? (
                <>
                  <TableCell align="left">
                    <strong>{isInternational ? DASHBOARD_COMMODITY.WEIGHT : DASHBOARD_COMMODITY.UNIT_WEIGHT}</strong>
                  </TableCell>
                  <TableCell align="left">
                    <strong>{isInternational ? DASHBOARD_COMMODITY.QUANTITY : DASHBOARD_COMMODITY.UNIT_QUANTITY}</strong>
                  </TableCell>
                  <TableCell align="left">
                    <strong>{DASHBOARD_COMMODITY.UNIT_VALUE}</strong>
                  </TableCell>
                  <TableCell align="left" className="commodity-country-origin commodity-border-bottom">
                    <strong>{isInternational ? DASHBOARD_COMMODITY.COUNTRY_ORIGIN : DASHBOARD_COMMODITY.COUNTRY_MANUFACTURE}</strong>
                  </TableCell>
                </>
              ) : null}
              {isInternational ? null : (
                <>
                  {shipmentMovementType !== CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B ? (
                    <TableCell align="left" className="commodity-country-origin commodity-border-bottom">
                      <strong>{isInternational ? DASHBOARD_COMMODITY.QUANTITY : DASHBOARD_COMMODITY.UNIT_QUANTITY}</strong>
                    </TableCell>
                  ) : null}
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {shipmentDetails?.commodityDetails?.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.commodityCode ? row.commodityCode : '-'}
                </TableCell>
                <TableCell align="left">{row.fullDescriptionOfGoods}</TableCell>

                {isInternational ||
                (!isInternational && shipmentMovementType === CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B) ? (
                  <>
                    <TableCell align="left">{row.weight} kg</TableCell>
                    <TableCell align="left">{row.quantity}</TableCell>
                    <TableCell align="left">{row.unitValue}</TableCell>
                    <TableCell align="left" className="commodity-country-origin commodity-border-bottom">
                      {(row.countryOfOrigin || {}).code}
                    </TableCell>
                  </>
                ) : null}
                {isInternational ? null : (
                  <>
                    {shipmentMovementType !== CLERANCE_DECLARATION.MOVEMENT_TYPE_B2B ? (
                      <TableCell align="left" className="commodity-country-origin commodity-border-bottom">
                        {row.quantity}
                      </TableCell>
                    ) : null}
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
          {!isClearance ? (
            <TableFooter>
              {!isAddNewAddress ? (
                <>
                  {' '}
                  <TableRow variant="head" className="footerRow">
                    <TableCell align="left">{DASHBOARD_COMMODITY.SUB_TOTAL}</TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>

                    <TableCell align="right" className="commodity-country-origin commodity-border-bottom">
                      {shipmentDetails.subTotal}
                    </TableCell>
                  </TableRow>
                  <TableRow variant="head" className="footerRow">
                    <TableCell align="left">{DASHBOARD_COMMODITY.SHIPPING_COST}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>

                    <TableCell align="right" className="commodity-country-origin commodity-border-bottom">
                      {isNaN(shipmentDetails.customDeclarationShippingCharges) ||
                      parseInt(shipmentDetails.customDeclarationShippingCharges) < 0
                        ? 0
                        : shipmentDetails.customDeclarationShippingCharges}
                    </TableCell>
                  </TableRow>
                </>
              ) : null}
              <TableRow variant="head" className="footerRow">
                <TableCell align="left">
                  <strong>{CLERANCE_DECLARATION.TOTAL_VALUE}</strong>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>

                <TableCell align="right" className="commodity-country-origin commodity-border-bottom">
                  <strong>{shipmentDetails.totalValue}</strong>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default CommodityDetailsSummary;
